import React, { useState } from 'react';
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaCopy, FaInstagram } from 'react-icons/fa';
import { MdEmail, MdSms } from 'react-icons/md';
import { trackInvitation } from '../Services/InviteApi';
import './SocialInviteModal.css';

const SocialInviteModal = ({ show, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [linkedinCopied, setLinkedinCopied] = useState(false);
  const [instagramCopied, setInstagramCopied] = useState(false);
  
  const inviteLink = `${window.location.origin}/signup?ref=${localStorage.getItem('user_id')}`;
  const inviteMessage = "Join me on Dyrect - the ultimate platform for creators! Create amazing content and connect with fellow creators.";

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      
      try {
        await trackInvitation(localStorage.getItem('user_id'), 'copy_link', inviteLink);
      } catch (error) {
        console.error('Failed to track invitation:', error);
      }
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleShare = async (platform) => {
    const encodedMessage = encodeURIComponent(inviteMessage);
    const encodedLink = encodeURIComponent(inviteLink);
    const fullMessage = `${inviteMessage} ${inviteLink}`;
    
    if (platform === 'linkedin') {
      try {
        await navigator.clipboard.writeText(fullMessage);
        setLinkedinCopied(true);
        setTimeout(() => setLinkedinCopied(false), 3000);
        window.open('https://www.linkedin.com/messaging/', '_blank', 'width=800,height=600,noopener,noreferrer');
      } catch (err) {
        console.error('Failed to copy message:', err);
        // Fallback to regular LinkedIn share(posts to feed, not messaging)
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}&summary=${encodedMessage}`, '_blank', 'width=600,height=400,noopener,noreferrer');
      }
    } else if (platform === 'instagram') {
      await navigator.clipboard.writeText(fullMessage);
      setInstagramCopied(true);
      setTimeout(() => setInstagramCopied(false), 3000);
      window.open(`https://www.instagram.com/direct/new/?text=${encodedMessage}%20${encodedLink}`, '_blank', 'width=600,height=400,noopener,noreferrer');
    } else {
      const shareUrls = {
        whatsapp: `https://wa.me/?text=${encodedMessage}%20${encodedLink}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedMessage}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodedMessage}%20${encodedLink}`,
        email: `mailto:?subject=Join me on Dyrect&body=${encodedMessage}%20${encodedLink}`,
        sms: `sms:?body=${encodedMessage}%20${encodedLink}`
      };

      if (shareUrls[platform]) {
        window.open(shareUrls[platform], '_blank', 'width=600,height=400,noopener,noreferrer');
      }
    }

    try {
      await trackInvitation(localStorage.getItem('user_id'), platform, inviteLink);
    } catch (error) {
      console.error('Failed to track invitation:', error);
    }
  };

  if (!show) return null;

  return (
    <div className="social-invite-overlay">
      <div className="social-invite-modal">
        <div className="social-invite-header">
          <h2>Invite Friends to Dyrect</h2>
          <button className="social-invite-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="social-invite-content">
          <p className="social-invite-description">
            Share Dyrect with your friends and help them discover the ultimate creator platform!
          </p>
          
          <div className="social-invite-link-section">
            <div className="social-invite-link-container">
              <input 
                type="text" 
                value={inviteLink} 
                readOnly 
                className="social-invite-link-input"
              />
              <button 
                className={`social-invite-copy-btn ${copied ? 'copied' : ''}`}
                onClick={handleCopyLink}
              >
                <FaCopy />
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>

          <div className="social-invite-share-options">
            <h3>Share via:</h3>
            <div className="social-invite-share-buttons">
              <button 
                className="social-invite-share-btn whatsapp"
                onClick={() => handleShare('whatsapp')}
              >
                <FaWhatsapp />
                <span>WhatsApp</span>
              </button>
              
              {/* <button 
                className="social-invite-share-btn facebook"
                onClick={() => handleShare('facebook')}
              >
                <FaFacebook />
                <span>Facebook</span>
              </button> */}
              <button 
                className={`social-invite-share-btn instagram ${instagramCopied ? 'copied' : ''}`}
                onClick={() => handleShare('instagram')}
              >
                <FaInstagram />
                <span>Instagram</span>
              </button>
              
              <button 
                className={`social-invite-share-btn linkedin ${linkedinCopied ? 'copied' : ''}`}
                onClick={() => handleShare('linkedin')}
              >
                <FaLinkedin />
                <span>LinkedIn</span>
              </button>
            </div>
          </div>
          {linkedinCopied && (
            <div className="toast-message toast-bgcolor"
            >
              Invite link copied! Paste it in LinkedIn messaging.
            </div>
          )}
          {instagramCopied && (
            <div className="toast-message toast-bgcolor">
              Invite link copied! Paste it in Instagram messaging.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialInviteModal;